import script from "./forgetPassworld.vue?vue&type=script&setup=true&lang=js"
export * from "./forgetPassworld.vue?vue&type=script&setup=true&lang=js"

import "./forgetPassworld.vue?vue&type=style&index=0&id=d704eda4&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d704eda4"]])

export default __exports__